"use strict";

/**
 * Copyright 2018 Google LLC
 *
 * Distributed under MIT license.
 * See file LICENSE for detail or copy at https://opensource.org/licenses/MIT
 */
var _createClass = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _asyncToGenerator = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleToken = void 0;
var fs = require("fs");
var gaxios_1 = require("gaxios");
var jws = require("jws");
var path = require("path");
var util_1 = require("util");
var readFile = fs.readFile ? util_1.promisify(fs.readFile) : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        throw new ErrorWithCode('use key rather than keyFile.', 'MISSING_CREDENTIALS');
      case 1:
      case "end":
        return _context.stop();
    }
  }, _callee);
}));
var GOOGLE_TOKEN_URL = 'https://www.googleapis.com/oauth2/v4/token';
var GOOGLE_REVOKE_TOKEN_URL = 'https://accounts.google.com/o/oauth2/revoke?token=';
var ErrorWithCode = /*#__PURE__*/function (_Error) {
  _inherits(ErrorWithCode, _Error);
  function ErrorWithCode(message, code) {
    var _this;
    _classCallCheck(this, ErrorWithCode);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorWithCode).call(this, message));
    _this.code = code;
    return _this;
  }
  return ErrorWithCode;
}(_wrapNativeSuper(Error));
var getPem;
var GoogleToken = /*#__PURE__*/function () {
  /**
   * Create a GoogleToken.
   *
   * @param options  Configuration object.
   */
  function GoogleToken(options) {
    _classCallCheck(this, GoogleToken);
    this.configure(options);
  }
  _createClass(GoogleToken, [{
    key: "hasExpired",
    /**
     * Returns whether the token has expired.
     *
     * @return true if the token has expired, false otherwise.
     */
    value: function hasExpired() {
      var now = new Date().getTime();
      if (this.rawToken && this.expiresAt) {
        return now >= this.expiresAt;
      } else {
        return true;
      }
    }
    /**
     * Returns whether the token will expire within eagerRefreshThresholdMillis
     *
     * @return true if the token will be expired within eagerRefreshThresholdMillis, false otherwise.
     */
  }, {
    key: "isTokenExpiring",
    value: function isTokenExpiring() {
      var _a;
      var now = new Date().getTime();
      var eagerRefreshThresholdMillis = (_a = this.eagerRefreshThresholdMillis) !== null && _a !== void 0 ? _a : 0;
      if (this.rawToken && this.expiresAt) {
        return this.expiresAt <= now + eagerRefreshThresholdMillis;
      } else {
        return true;
      }
    }
  }, {
    key: "getToken",
    value: function getToken(callback) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (typeof callback === 'object') {
        opts = callback;
        callback = undefined;
      }
      opts = Object.assign({
        forceRefresh: false
      }, opts);
      if (callback) {
        var cb = callback;
        this.getTokenAsync(opts).then(function (t) {
          return cb(null, t);
        }, callback);
        return;
      }
      return this.getTokenAsync(opts);
    }
    /**
     * Given a keyFile, extract the key and client email if available
     * @param keyFile Path to a json, pem, or p12 file that contains the key.
     * @returns an object with privateKey and clientEmail properties
     */
  }, {
    key: "getCredentials",
    value: function () {
      var _getCredentials = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(keyFile) {
        var ext, key, body, privateKey, clientEmail, _privateKey, _privateKey2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              ext = path.extname(keyFile);
              _context2.t0 = ext;
              _context2.next = _context2.t0 === '.json' ? 4 : _context2.t0 === '.der' ? 13 : _context2.t0 === '.crt' ? 13 : _context2.t0 === '.pem' ? 13 : _context2.t0 === '.p12' ? 17 : _context2.t0 === '.pfx' ? 17 : 25;
              break;
            case 4:
              _context2.next = 6;
              return readFile(keyFile, 'utf8');
            case 6:
              key = _context2.sent;
              body = JSON.parse(key);
              privateKey = body.private_key;
              clientEmail = body.client_email;
              if (!(!privateKey || !clientEmail)) {
                _context2.next = 12;
                break;
              }
              throw new ErrorWithCode('private_key and client_email are required.', 'MISSING_CREDENTIALS');
            case 12:
              return _context2.abrupt("return", {
                privateKey: privateKey,
                clientEmail: clientEmail
              });
            case 13:
              _context2.next = 15;
              return readFile(keyFile, 'utf8');
            case 15:
              _privateKey = _context2.sent;
              return _context2.abrupt("return", {
                privateKey: _privateKey
              });
            case 17:
              if (getPem) {
                _context2.next = 21;
                break;
              }
              _context2.next = 20;
              return Promise.resolve().then(function () {
                return require('google-p12-pem');
              });
            case 20:
              getPem = _context2.sent.getPem;
            case 21:
              _context2.next = 23;
              return getPem(keyFile);
            case 23:
              _privateKey2 = _context2.sent;
              return _context2.abrupt("return", {
                privateKey: _privateKey2
              });
            case 25:
              throw new ErrorWithCode('Unknown certificate type. Type is determined based on file extension. ' + 'Current supported extensions are *.json, *.pem, and *.p12.', 'UNKNOWN_CERTIFICATE_TYPE');
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getCredentials(_x) {
        return _getCredentials.apply(this, arguments);
      }
      return getCredentials;
    }()
  }, {
    key: "getTokenAsync",
    value: function () {
      var _getTokenAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(opts) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.inFlightRequest && !opts.forceRefresh)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", this.inFlightRequest);
            case 2:
              _context3.prev = 2;
              _context3.next = 5;
              return this.inFlightRequest = this.getTokenAsyncInner(opts);
            case 5:
              return _context3.abrupt("return", _context3.sent);
            case 6:
              _context3.prev = 6;
              this.inFlightRequest = undefined;
              return _context3.finish(6);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2,, 6, 9]]);
      }));
      function getTokenAsync(_x2) {
        return _getTokenAsync.apply(this, arguments);
      }
      return getTokenAsync;
    }()
  }, {
    key: "getTokenAsyncInner",
    value: function () {
      var _getTokenAsyncInner = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(opts) {
        var creds;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.isTokenExpiring() === false && opts.forceRefresh === false)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", Promise.resolve(this.rawToken));
            case 2:
              if (!(!this.key && !this.keyFile)) {
                _context4.next = 4;
                break;
              }
              throw new Error('No key or keyFile set.');
            case 4:
              if (!(!this.key && this.keyFile)) {
                _context4.next = 11;
                break;
              }
              _context4.next = 7;
              return this.getCredentials(this.keyFile);
            case 7:
              creds = _context4.sent;
              this.key = creds.privateKey;
              this.iss = creds.clientEmail || this.iss;
              if (!creds.clientEmail) {
                this.ensureEmail();
              }
            case 11:
              return _context4.abrupt("return", this.requestToken());
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getTokenAsyncInner(_x3) {
        return _getTokenAsyncInner.apply(this, arguments);
      }
      return getTokenAsyncInner;
    }()
  }, {
    key: "ensureEmail",
    value: function ensureEmail() {
      if (!this.iss) {
        throw new ErrorWithCode('email is required.', 'MISSING_CREDENTIALS');
      }
    }
  }, {
    key: "revokeToken",
    value: function revokeToken(callback) {
      if (callback) {
        this.revokeTokenAsync().then(function () {
          return callback();
        }, callback);
        return;
      }
      return this.revokeTokenAsync();
    }
  }, {
    key: "revokeTokenAsync",
    value: function () {
      var _revokeTokenAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var url;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.accessToken) {
                _context5.next = 2;
                break;
              }
              throw new Error('No token to revoke.');
            case 2:
              url = GOOGLE_REVOKE_TOKEN_URL + this.accessToken;
              _context5.next = 5;
              return gaxios_1.request({
                url: url
              });
            case 5:
              this.configure({
                email: this.iss,
                sub: this.sub,
                key: this.key,
                keyFile: this.keyFile,
                scope: this.scope,
                additionalClaims: this.additionalClaims
              });
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function revokeTokenAsync() {
        return _revokeTokenAsync.apply(this, arguments);
      }
      return revokeTokenAsync;
    }()
    /**
     * Configure the GoogleToken for re-use.
     * @param  {object} options Configuration object.
     */
  }, {
    key: "configure",
    value: function configure() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.keyFile = options.keyFile;
      this.key = options.key;
      this.rawToken = undefined;
      this.iss = options.email || options.iss;
      this.sub = options.sub;
      this.additionalClaims = options.additionalClaims;
      if (typeof options.scope === 'object') {
        this.scope = options.scope.join(' ');
      } else {
        this.scope = options.scope;
      }
      this.eagerRefreshThresholdMillis = options.eagerRefreshThresholdMillis;
    }
    /**
     * Request the token from Google.
     */
  }, {
    key: "requestToken",
    value: function () {
      var _requestToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var iat, additionalClaims, payload, signedJWT, r, body, desc;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              iat = Math.floor(new Date().getTime() / 1000);
              additionalClaims = this.additionalClaims || {};
              payload = Object.assign({
                iss: this.iss,
                scope: this.scope,
                aud: GOOGLE_TOKEN_URL,
                exp: iat + 3600,
                iat: iat,
                sub: this.sub
              }, additionalClaims);
              signedJWT = jws.sign({
                header: {
                  alg: 'RS256'
                },
                payload: payload,
                secret: this.key
              });
              _context6.prev = 4;
              _context6.next = 7;
              return gaxios_1.request({
                method: 'POST',
                url: GOOGLE_TOKEN_URL,
                data: {
                  grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
                  assertion: signedJWT
                },
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                responseType: 'json'
              });
            case 7:
              r = _context6.sent;
              this.rawToken = r.data;
              this.expiresAt = r.data.expires_in === null || r.data.expires_in === undefined ? undefined : (iat + r.data.expires_in) * 1000;
              return _context6.abrupt("return", this.rawToken);
            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](4);
              this.rawToken = undefined;
              this.tokenExpires = undefined;
              body = _context6.t0.response && _context6.t0.response.data ? _context6.t0.response.data : {};
              if (body.error) {
                desc = body.error_description ? ": ".concat(body.error_description) : '';
                _context6.t0.message = "".concat(body.error).concat(desc);
              }
              throw _context6.t0;
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 13]]);
      }));
      function requestToken() {
        return _requestToken.apply(this, arguments);
      }
      return requestToken;
    }()
  }, {
    key: "accessToken",
    get: function get() {
      return this.rawToken ? this.rawToken.access_token : undefined;
    }
  }, {
    key: "idToken",
    get: function get() {
      return this.rawToken ? this.rawToken.id_token : undefined;
    }
  }, {
    key: "tokenType",
    get: function get() {
      return this.rawToken ? this.rawToken.token_type : undefined;
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this.rawToken ? this.rawToken.refresh_token : undefined;
    }
  }]);
  return GoogleToken;
}();
exports.GoogleToken = GoogleToken;